var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.el,_vm._b({tag:"component",staticClass:"stack-router-child scale-95",class:{
    'mb-10 md:mb-0 md:mr-12 z-30 bg-white bg-opacity-75 backdrop-filter backdrop-blur-md':
      _vm.inBackground,
    'z-40 scale-100': _vm.inForeground,
  },on:{"close":_vm.onClose,"open":function($event){return _vm.$emit('open')}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true},{key:"footer",fn:function(){return [_vm._t("footer")]},proxy:true}],null,true),model:{value:(_vm.showModel),callback:function ($$v) {_vm.showModel=$$v},expression:"showModel"}},'component',Object.assign({}, {id: _vm.id,
    hideBackdrop: true},
    _vm.$attrs),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }